import React from "react";
import { PublicShell, BackButton } from "@/components/Layout";
import { fmtSASTDate } from "@/lib/api";

export function Terms() {
  return (
    <PublicShell>
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16 prose prose-slate">
        <BackButton to="/" label="Back to home" />
        <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Legal</p>
        <h1 className="font-display mt-2 text-4xl tracking-tight font-bold text-[#0A2540]">Terms & Conditions</h1>
        <p className="mt-4 text-sm text-[#666666]">Last updated: {fmtSASTDate()}</p>
        <div className="mt-8 space-y-6 text-[#333333] leading-relaxed text-base">
          <p>FlexiVouch is a brand owned and operated by Praxio (Pty) Ltd ("Praxio", "we", "us"). By accessing or using the FlexiVouch platform you agree to these Terms & Conditions.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">1. Vouchers</h2>
          <p>FlexiVouch vouchers are stored-value instruments. They represent monetary value that may be spent across multiple FlexiVouch-supported services. Vouchers expire 3 years from issuance unless otherwise stated.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">2. Merchant obligations</h2>
          <p>Merchants must complete KYC verification before generating vouchers. Wallet balances are prepaid and must be funded via approved deposit methods. Praxio reserves the right to suspend any account for suspicious activity or non-compliance.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">3. Liability</h2>
          <p>To the maximum extent permitted by South African law, Praxio's liability is limited to the value of any voucher in dispute. We are not liable for losses arising from compromised PINs, customer negligence, or third-party provider failures.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">4. Governing law</h2>
          <p>These terms are governed by the laws of the Republic of South Africa.</p>
        </div>
      </section>
    </PublicShell>
  );
}

export function Privacy() {
  return (
    <PublicShell>
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <BackButton to="/" label="Back to home" />
        <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Legal</p>
        <h1 className="font-display mt-2 text-4xl tracking-tight font-bold text-[#0A2540]">Privacy Policy</h1>
        <p className="mt-4 text-sm text-[#666666]">Last updated: {fmtSASTDate()}</p>
        <div className="mt-8 space-y-6 text-[#333333] leading-relaxed text-base">
          <p>Praxio (Pty) Ltd operates FlexiVouch in compliance with the Protection of Personal Information Act (POPIA), 2013.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">1. What we collect</h2>
          <p>We collect identity information (full name, SA ID, address, cellphone), KYC documents, transaction history, and platform usage data necessary to operate the voucher service.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">2. How we use your data</h2>
          <p>To verify identity, prevent fraud, process voucher transactions, settle merchant balances, and to comply with applicable laws.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">3. How we protect your data</h2>
          <p>Passwords are stored as bcrypt hashes. Voucher PINs are stored as HMAC-SHA256 fingerprints — never as plaintext. KYC documents are stored in encrypted object storage.</p>
          <h2 className="font-display text-2xl font-semibold text-[#0A2540]">4. Your rights</h2>
          <p>You may request access, correction, or deletion of your personal data at any time by contacting info@praxio.co.za.</p>
        </div>
      </section>
    </PublicShell>
  );
}
